<template>
  <div class="responds-tables">
    <Alert
      v-if="similarTableList.length"
      text="Обнаружены "
      buttonLabel="похожие кандидаты"
      class="responds-tables__alert"
      @buttonClick="buttonClick"
    />

    <SubpanelTable
      :tableColumns="tableTitle"
      :tableData="tableList"
      @rowClick="val => goToModule('vacancies', val?.vacancy_id?.value)"
      ref="respond-table"
    ></SubpanelTable>
    <div
      v-if="similarTableList.length"
      class="similar-table"
      id="SubpanelTable"
    >
      <p class="similar-table__title">Найденные кандидаты</p>
      <SubpanelTable
        :tableColumns="similarTableTitle"
        :tableData="similarTableList"
        @rowClick="
          val => goToModule('candidates', val?.hrpac_candidates_id?.value)
        "
      ></SubpanelTable>
    </div>
  </div>
</template>

<script>
import Alert from 'Elements/Alert/Alert';
import SubpanelTable from 'Elements/Table/SubpanelTable';

export default {
  props: {
    id: String,
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    tableTitle() {
      return this.data?.hrpac_responds?.data?.title || {};
    },
    tableList() {
      return this.data?.hrpac_responds?.data?.List || [];
    },
    similarTableTitle() {
      return this.data?.hrpac_selection_stage_candidates_1?.data?.title || {};
    },
    similarTableList() {
      return this.data?.hrpac_selection_stage_candidates_1?.data?.List || [];
    }
  },
  methods: {
    goToModule(moduleName, recordId) {
      if (recordId) {
        window.open(`/${moduleName}/${recordId}`, '_blank');
      }
    },
    buttonClick() {
      const respondTableHeight = this.$refs['respond-table'].$el.offsetHeight;

      const container = document.querySelector('.respond-card__page');
      container.scrollTo({
        top: container.offsetHeight - respondTableHeight - 48,
        behavior: 'smooth'
      });
    }
  },
  components: {
    SubpanelTable,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.responds-tables {
  padding: 0 24px 24px;

  &__alert {
    margin: 18px 0 16px 0;
  }
}
.similar-table {
  margin-top: 17px;

  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: $grey64;
    margin: 16px 0 8px 0;
  }
}
</style>
